import { defineMessages } from 'react-intl';

const translations = {
  helpText: {
    sendCloudWarning: {
      id: 'components.addressForm.fields.organisation.helpText.sendCloudWarning',
      defaultMessage:
        'To prevent errors at SendCloud we advise to use 35 characters or less in this field, currently {length}',
      description: 'helper text for organisation field when sendcloud is active',
    },
  },
  fields: {
    given_name: {
      id: 'properties.given_name',
      defaultMessage: 'First name',
      description: 'label of the given name field',
    },
    additional_name: {
      id: 'properties.additional_name',
      defaultMessage: 'Last name prefix',
      description: 'label of the additional name field',
    },
    family_name: {
      id: 'properties.family_name',
      defaultMessage: 'Last name',
      description: 'label of the last name field',
    },
    company: {
      id: 'properties.company',
      defaultMessage: 'Company',
      description: 'label of the company field',
    },
    country: {
      id: 'properties.country',
      defaultMessage: 'Country',
      description: 'label of the country field',
    },
    thoroughfare: {
      id: 'properties.thoroughfare',
      defaultMessage: 'Street',
      description: 'label of the thoroughfare field',
    },
    premise_number: {
      id: 'properties.premise_number',
      defaultMessage: 'House number',
      description: 'label of the premise number field',
    },
    premise_number_suffix: {
      id: 'properties.premise_number_suffix',
      defaultMessage: 'Suffix',
      description: 'label of the premise number suffix field',
    },
    locality: {
      id: 'properties.locality',
      defaultMessage: 'City',
      description: 'label of the locality field',
    },
    postal_code: {
      id: 'properties.postal_code',
      defaultMessage: 'Postal code',
      description: 'label of the postal code field',
    },
    administrative_area: {
      id: 'properties.administrative_area',
      defaultMessage: 'Administrative area',
      description: 'label of the administrative area field',
    },
    isPrimary: {
      id: 'properties.isPrimary',
      defaultMessage: 'Primary',
      description: 'label of the is primary field',
    },
    setAsShippingAddress: {
      id: 'properties.setAsShippingAddress',
      defaultMessage: 'Add as shipping address',
      description: 'label of the set as shipping address field',
    },
    setAsBillingAddress: {
      id: 'properties.setAsBillingAddress',
      defaultMessage: 'Add as billing address',
      description: 'label of the set as billing address field',
    },
  },
};

export default defineMessages(translations);
